export default {
  //common
  passwordLabel: "Password",
  confirmPassword: "Confirm Password",
  login_Button: "LOGIN",
  login_id_required: "Login ID is required",
  password_required: "Password is required",
  forgot_Password: "Forgot Password?",
  forgot_PasswordPage: "Forgot Password",
  descLogin: "By clicking ‘Login’, you acknowledge that you have reviewed",
  agreeLogin: "& agree to our",
  termsConditions: "Terms & conditions",
  privacyLogin: "Privacy Policy",
  disclaimer: "Disclaimer",
  tipsSafeBanking: "Tips for Safe Banking",
  firstTimeUser: "First time user",
  registerHere: "Register here",
  accountNumberLabel: "Account Number",
  selectAccountNumber: "Select Account Number",
  accountHolderName: "Account Holder Name",
  account_required: "Account Number is required",
  accountType_required: "Account Type is required",
  accountHolderName_required: "Account Holder Name is required",
  messageNoRecordFound: "Sorry, no matching records found",
  accountNumberLabelPlaceholder: "Select Account Number",

  //Corporate Login
  domainId: "Domain ID/Company ID",
  useridCor: "User ID",
  useridCorRequired: "User ID is required",
  userIdPlaceholder: "Your User ID",
  domainIdRequired: "Domain ID/Company ID is required",
  PasswordCor: "Password",
  confirm_PasswordCor: "Confirm Password",
  PasswordCorRequired: "Password is required",
  confirmPasswordCorRequired: "Confirm Password is required",
  patternMessage: "Password does not meet requirements",
  corForgotMsgHeading: "Please enter the Domain ID/Company ID, we will send the OTP to registered mobile number",
  sendButton: "Send",

  //Register Login
  card_RegisterHeading: "Register",
  card_WithCard: "With Card",
  Card_withCustNo: "With Customer No.",
  Card_CustomerNo: "Customer Number",
  Card_CustomerNoRequired: "Customer No is required",
  Card_CardNo: "Card No",
  Card_CardNoRequired: "Card No is required",
  Card_CVV: "CVV",
  Card_CVVRequired: "CVV is required",
  CVV_Format: "Please Enter valid CVV Format",
  Card_expiryDate: "Expiry date",
  accept_msg: "I accept the",
  card_termscondition: "Terms & Conditions",
  card_registerButton: "Register",
  withCustNo: "Please enter the customer number, we will send the OTP to registered mobile number",


  //Account Statement
  fromDate: "From Date",
  toDate: "To Date",
  buttonSubmit: "Submit",
  buttonReset: "Reset",
  buttonCancel: "Cancel",
  buttonAccept: "Accept",
  BalanceLabel: "Balance",
  accountTypeLabel: "Account Type",
  noDataAvailable: "No data available",
  processPDF: "Process Pdf",
  viewPDF: "View Pdf",

  statementList: "Statement List",
  column_download: "Download",
  statement_columnFromDate: "From Date",
  statement_columnToDate: "To Date",
  statement_columnFileName: "File Name",
  statement_columnStatus: "Status",
  statement_columnAccNumber: "Account Number",
  statement_createdBy: "Created By",
  statement_createdDate: "Created Date",
  statementDownloadInfo: "Dear Customer, to maintain confidentiality and protect your privacy, your e-statement is password protected.",
  estatementPssword: "e-Statement Password:",
  downloadInfoThirdLine: "To view your Account e-Statement, simply enter your Customer Number as a password.",
  forEx: "For example:",
  downloadInfoCustomer: "- If your customer number is",
  downloadCustNo: "123456",
  downloadCustNo4digit: "123456",
  downloadInfoLast: ", then your password will be",
  downloadExCustNo: "004561",
  downloadExCustNo4digit: "4561",
  downloadConfirmationMessage: "Are you sure you want to download your e-statement?",
  NoButtonDownload: "No",
  YesButtonDownload: "Yes",


  //Header
  Header_IB: "Welcome to Internet Banking",
  Header_CB: "Welcome to Corporate Banking",
  Header_lastlogin: "Last Login",


  login_enterdetailsheading: "Please enter your details.",
  login_LoginIdLabel: "Login ID",
  login_validationLoginId: "ID must be 4 uppercase letters followed by 8 digits",
  login_forgotPassword: "Forgot Password",
  login_termsText: "By clicking ‘Login’, you acknowledge that you have reviewed",
  login_agreetext: "& agree to our",
  login_termsCondition: "Terms & conditions",
  login_privacypolicy: "Privacy Policy",
  login_disclaimer: "Disclaimer",
  login_tipsforsafe: "Tips for Safe Banking",
  login_copyright: "Copyright 2026 | All Rights Reserved By",
  login_footerDeveloped: "Developed by",
  login_footerSaraswat: "Saraswat Infotech Private Limited",

  //FORGET Password internet banking
  forgetpassword: "Forgot Password",
  forgetpassword_message: "Please enter the customer number, we will send the OTP to registered mobile number",
  forgetpassword_Loginid: "Login ID",
  forgetpassword_send: "Send",

  resetPassword: "Reset Password",

  //OTP internet banking
  otp_loginHeading: "Login to Internet Banking",
  otp_enterHeading: "Enter Four Digit OTP",
  otp_messageError: "You have",
  otp_messageErrorleftMessage: "attempt left",

  //Home.js
  home_HeadingAccountDetails: "Account Details",
  home_HeadingAccountStatement: "Account Statement",
  home_HeadingStatement: "Summary",
  home_financial: "Financial Overview",
  miniStatementSummary: "Mini Statement",
  laonSummary: "Loans",
  loanStmtHeading: "Loan Statement",
  sumMiniStmtColumntransDate: "Transaction Date",
  sumMiniStmtColumnParticulars: "Particulars",
  sumMiniStmtColumnStatus: "Status",
  sumMiniStmtColumnAmount: "Amount",

  //Account.js
  AccountStatementsHeading: "Account Statements",
  PerSetCustLimit: "Set Customer Limit",

  //Account Main Haeding
  accountSummary_Heading: "Account Balance Summary",
  accountTable_Heading: "Account Holder Name",
  account_Statement: "Account Statement",
  account_customerLimit: "Set Customer Limit",
  accountTable_accountName: "Account Number",
  accountTable_accountType: "Account Type",
  accountTable_Balance: "Balance",
  accountTable_Details: "Details",
  accountTable_Branchcode: "Branch Code",
  account_miniStatement: "Mini Statement",
  account_Loan: "Loan",
  ministatement_account: "Select Account",
  statement_Heading: "Transaction Statement",
  transaction_Date: "transaction_Date",

  //Customer Limit
  accountSetCust_Heading: "Set Customer Limit",
  customerNoSetLimit: "Customer Number",
  selectCustomerNoSetLimit: "Select Customer Number",
  custNoIsrequired: "Customer Number is required",
  neftCustLimit: "NEFT",
  rtgsCustLimit: "RTGS",
  internalCustLimit: "INTERNAL",
  perDayTranxLimit: "Per Day Transaction Limit",
  currentLimit: "Current Limit",
  perDayMaxTranxLimit: "Per Day Transaction Max Amount :",

  //AccountStatement
  noRowsDisplayMessage: "No Rows",
  recentTransaction: "Recent Transactions",
  accStmtSelectAcc: "Select Account",
  transStatementHeading: "Transaction Statement",
  accStmtColumntransDate: "Transaction Date",
  accStmtColumnParticulars: "Particulars",
  accStmtColumnStatus: "Status",
  accStmtColumnAmount: "Amount",

  //Beneficiary
  column_nickname: "Nickname",
  column_name: "Name",
  column_acconno: "Account Number",
  column_Ifsc: "IFSC",
  column_createdDatenadTime: "Created Date and Time",
  column_delete: "Delete",
  add_Benficiary: "Add Beneficiary",

  //Beneficiary Master
  BeneAccountNumber: "Account Number",
  BeneAccountNumberReq: "Account Number is required",
  BeneIFSCCode: "IFSC Code",
  BeneIFSCCodeReq: "IFSC Code is required",
  validIFSCCode: "Please enter a valid IFSC code",
  BeneNickname: "Nickname",
  BeneNicknameReq: "Nickname is required",
  BeneFullName: "Full Name",
  BeneFullNameReq: "Full Name is required",
  BeneMobileNumber: "Mobile Number",
  buttonReset: "Reset",
  buttonAddBeneficiary: "Add Beneficiary",
  beneficiary_Verified: "Beneficiary Verified",
  next_Button: "NEXT",
  pattern_nickname: "Please enter a combination of letters and numbers",
  acc_HolderName: "Account Holder Name",
  acc_HolderNameReq: "Account Holder Name is required",
  mobile_Valid: "Please Enter valid Mobile Number",


  //other
  heading_otherbank: "Other Bank Beneficiary List",
  heading_withinBank: "Within Bank Beneficiary List",
  //Other Bank Corporate
  headingOtherBank: "Add Other Bank Beneficiary",

  // Within Bank
  headingWithinBank: "Add Within Bank Beneficiary",
  Cor_accountholdname: "Account Holder Name in CBS",
  Validate: "Validate",

  //Transfer History
  transferHistoryHeading: "Transfer History",
  transferReport: " Transaction Report",
  column_ViewReceipt: "View Receipt",
  column_TransTransactionDate: "Transaction Date",
  column_TransactionTyep: "Transaction Type",
  column_RemitterAcNo: "Remitter A/C No",
  column_BeneficiaryAcNo: "Beneficiary A/C No",
  column_BeneficiaryIFSC: "Beneficiary IFSC",
  column_BeneName: "Beneficiary Name",
  column_BeneAmount: "Transaction Amount",
  column_BeneRRN: "RRN",
  column_ResponseCode: "Response Code",

  //Fund Transfer
  column_pay: "Proceed To Pay",
  column_nickname: "Nickname",
  column_name: "Name",
  column_accountno: "Account Number",
  column_ifsc: "IFSC",
  column_status: "Status",
  remitterDetails: "Remitter Details",
  availableBalance: "Available Balance:",
  beneficiaryDetails: "Beneficiary Details",
  beneficiaryAccountNumber: "Beneficiary Account Number",
  beneficiaryAccountNumber_required: "Beneficiary Account Number is required",
  beneficiaryIFSC: "Beneficiary IFSC",
  beneficiaryIFSC_required: "Beneficiary IFSC is required",
  beneficiaryName: "Beneficiary Name",
  beneficiaryName_required: "Beneficiary Name is required",
  transferDetails: "Transfer Details",
  amount: "Amount",
  amount_required: "Amount is required",
  amount_validation: "Please Enter a valid Amount",
  tpin: "TPIN",
  tpin_required: "TPIN is required",
  tpin_info: "TPIN must contain only digits and have at least 4 digits",
  remark: "Remark",
  remark_required: "Remark is required",
  continue_Button: "Continue",

  //neft
  neft_mainHeading: "National Electronic Funds Transfer (NEFT)",
  neft_tableHeading: "Select Beneficiary To Proceed For Transaction",

  //Receipt


  rtgs_heading: "Real Time Gross Settlement (RTGS)",
  rtgs_tableHeading: "Select Beneficiary To Proceed For Transaction",
  validIFSC: "Please enter a valid IFSC code",
  validAmount: "Please Enter a valid Amount",

  //WithinBank
  withinbank_Heading: "Within Bank Fund Transfer",
  table_heading: "Beneficiary List",

  //Self account
  main_heading: "Self Account",

  //Personal Loans
  Per_loanMainHeading: "Loan Details",
  per_loanSubHeading: "Loan Account Summary",
  per_loanColView: "View",
  viewLoanDetails: "View Loan Details",
  per_loanColDisbursement: "Disbursement",
  disbursementDetails: "Disbursement Details",
  per_loanColRepayment: "Repayment",
  repaymentDetails: "Repayment Details",
  per_colLoanAccNo: "Loan Account No.",
  per_colLoanAmount: "Loan Amount",
  per_colLoanBalance: "Balance",
  per_colLoanEMI: "EMI",
  per_colLoanIntRate: "Interest Rate (%)",
  loans_AccountStatement: "Account Statement",
    deposit_AccountStatement: "Deposit Account Statement",
  loans_paymentHeading: "Loan Payment",
  loans_payNowButton: "Pay Now",
  loans_loanAccountNumber: "Loan Account Number",
  loans_loanAccountNumberRequired: "Loan Account Number is required",
  loansPayment_Amount: "Amount",
  loansPayment_AmountRequired: "Amount is required",
  loansPaymentTpin: "TPIN",
  loansPaymentTPINPattern: "TPIN must contain only digits and have at least 4 digits",
  loansPaymentTpinRequired: "TPIN is required",
  loansPayment_Remark: "Remark",
  loansPayment_Remark: "Remark is required",
  loansPayment_Apply: "Apply",
  customerNoLoans: "Customer Name/No.",
  customerNoLoansRequired: "Customer Name/No. is required",
  customerNoLoansPlaceholder: "Select Customer No.",

  loandisbursementDetails: "Loan Accounts details",
  loanCustomerName: "Customer name",
  sanctionAmount: "Sanction Amount",
  SanctionDate: "Sanction date",
  TotalDisbursedAmount: "Total Disbursed Amount",
  DisbursedStatus: "Disbursed Status",
  Disbursementdate: "Disbursement date",
  InterestRateloancol: "Interest Rate",
  DisbursementAmount: "Disbursement Amount",
  DisbursementDetail: "Disbursement Detail",
  LoanBranchCode: "Loan Branch Code",
  InterestRatepa: "Interest Rate (% .p.a)",
  LoanHolderName: "Loan Holder Name",
  LoanAccountType: "Account Type",
  LoanAccountStatus: "Account Status",
  DisbursalStatus: "Disbursal Status",
  InstallmentStart: "Installment Start",
  OutstandingAmount: "Outstanding Amount",
  CurrentMonthEMI: "Current Month EMI",
  InterestAppliedUptoDate: " Interest Applied Upto Date",
  UnutilizedLimit: "Unutilized Limit",
  ExpiryDate: "Expiry Date",

  //Repayment Details
  EffectiveDate: "Effective Date",
  InstallmentAmount: "Installment Amount",
  PrincipalAmount: "Principal Amount",
  InterestRecovered: "Interest Recovered",
  OSBalance: "O/S Balance",
  RepaymentDetail: "Repayment Detail",

  //Deposit Personal
  deposit_AccountNo: "Account No.",
  deposit_ineterestRate: "Interest Rate",
  ineterst_Month: "Month",
  interest_Days: "Day",
  interestDeposit_Rate: "Interest Rate(%)",
  interestDeposit_Date: "Interest Date",
  interestDepositType: "Deposit Type",

  //Deposit
  depositheading: "Deposit Account Details",
  costumerNo: "Customer No",
  costumerNoRequired: "Customer No is required",
  costumerNoPlaceholder: "Select Customer No",
  NodataAvailable: "No data avaliable",
  receiptNo: "Receipt No.",
  dateOfReceipt: "Date of Receipt",
  principalAmount: "Principle/Installment Amount",
  Balance_Deposit: "Balance",
  InterestRate: "Interest Rate (%)",
  maturityAmount: "Maturity Amount",
  maturityDate: "Maturity Date",
  LienAmount: "Lien Amount",
  asOfDate: "As of Date",
  openDeposit_Heading: "Open New Deposit",

  //Statement
  statement_heading: "Statement",
  date_message: "Please select a date range that falls within the 365 days",
  view_Button: "View",
  openingBalance: "Opening Balance:",
  dateColumn: "Date",
  particularColumn: "Particulars",
  instrumentsColumn: "Instruments",
  drAmountColumn: "Dr Amount",
  crAmountColumn: "Cr Amount",
  totalAmount: "Total Amount",


  //Cheque Request
  cheque_Heading: "ChequeBook Request",
  cheque_Delivery: "Delivery day",
  cheque_noOfPassbook: "No of ChequeBook",
  cheque_noOfPassbookNotZero:"Passbook count cannot be zero",
  cheque_maxAllowedValueIs3:"Maximum 3 cheque books allowed.",
  cheque_noOfPassbookRequired: "No of ChequeBook is required",
  cheque_deliveryRequired: "Delivery Day is required",
  cheque_Confirmation: "Are you sure you want to proceed with the cheque book request?",


  //Cheque Status
  cheque_StatusHeading: "ChequeBook Status",
  cheque_no: "Cheque No.",
  cheque_noRequired: "Cheque No. is required",

  //Profile
  profile_Title: "Profile Settings",
  button_updateTPIN: "Update TPIN",
  button_updatePssword: "Update Password",
  button_forgotTPIN: "Forgot TPIN?",
  profile_PersonalDetails: "Personal details",
  personalDetails_userName: "User Name",
  personalDetails_homeBranch: "Home Branch",
  personalDetails_Address: "Address",
  personalDetails_homeAddressBranch: "Home Branch Address",
  profile_ContactDetails: "Contact details",
  contactNo: "Contact Number",
  email_Address: "Email Address",
  communication_Address: "Communication Address",
  profile_Documents: "Documents",
  panCardNo: "Pan card no.",
  AadharCard: "Aadhar card no.",
  companyName: "Company Name",

  //Update Tpin
  updateTpin: "Update TPIN",
  oldTpin: "Old TPIN",
  oldTpinPlaceholder: "Please Enter Old TPIN",
  tpin_required: "TPIN is required",
  tpinPattern: "Please Enter valid TPIN",
  newTpin: "New TPIN",
  newTpinPlaceholder: "Please Enter New TPIN",
  confirmTpin: "Confirm TPIN",
  confirmTpinPlaceholder: "Please Confirm TPIN",
  tpinSubmit: "Submit",

  //updatePasswordModal
  updatePassword: "Update Password",
  passwordRequired: "Password is required",
  oldPassword: "Old Password",
  oldPasswordPlaceholder: "Please Enter Old Password",
  newPassword: "New Password",
  newPasswordPlaceholder: "Please Enter New Password",
  confirmPassword: "Confirm Password",
  confirmPasswordPlaceholder: "Please Confirm Password",
  update_SubmitButton: "Submit",

  //forgetTpinModal
  forgotTpinHeading: "Forgot TPIN",
  TpinOTP: "Enter OTP",

  //Complaint Support
  complaint_Heading: "Browse Customer Complaint Status",
  raiseComplaint_Button: "Raise Complaint",
  complaintViewColumn: "View",
  complaintComaplinId: "Complaint ID",
  complaintustomerNo: "Customer No",
  complaintMobileNo: "Mobile No",
  comaplaintEmail: "Customer Email",
  complaintName: "Name",
  complaintCategory: "Category",
  complaintSubject: "Subject",
  complaintMessage: "Message",
  complaintCreatedDate: "Created Date",
  complaintStatus: "Status",
  complaintResponsemsg: "Reply Msg",
  complaintReplyBy: "Reply By",
  complaintReplyDt: "Reply Dt",
  categoryRequired: "Category is required",
  subjectRequired: "Subject is required",
  messageRequired: "Message is required",
  complaintResetButton: "Reset",
  complaintSubmitButton: "Submit",
  supportTeamHeading: "Internet Banking Support Team",
  Helpdesk: "Helpdesk",
  officeHours: "Office Hours",
  bankTiming: "Bank remains closed on Sundays and every 2nd and 4th Saturday",
  compaintAddress: "Address",
  complaintEmail: "Email",

  //CORPORATEHOME
  Cor_AccountDetails: "Account Details",
  cor_AccountStatementHeading: "Account Statement",

  //Financial Overview
  financial_mainHeading: "Bank Account",
  finCol_AccHolderName: "Account Holder Name",
  finCol_AccNo: "Account Number",
  finCol_AccType: "Account Type",
  finCol_Balance: "Balance",
  finCol_Details: "Details",
  finNoDataAvailable: "No data avaliable",

  //Browse Beneficiary
  CorBrowseBeneficiary: "Beneficiary List",
  CorBeneficiaryType: "Beneficiary Type",
  CorBeneficiaryTypeRequired: "Beneficiary Type is required",
  CorAccHolderName: "Account Holder Name",
  CorSubmitBene: "Submit",
  BrowseColNickname: "Nickname",
  BrowseColName: "Name",
  BrowseColAccountNumber: "Account Number",
  BrowseColIFSC: "IFSC",
  BrowseColDelete: "Delete",

  //Payments
  selfAccountTransfer: "Self Account Transfer",
  fundTransferHeading: "Fund Transfer",
  col_srNo: "Sr. No.",
  col_TransDate: "Transaction Date",
  col_rrnNo: "RRN No",
  col_tType: "Transaction Type",
  col_cbsreceivedDate: "CBS Received Date",
  col_cbsSendDate: "CBS Send Date",
  col_cbsrrnNo: "CBS RRN",
  col_narration: "Narration",
  col_amountPayment: "Amount",
  col_RemAccountNo: "Remitter A/C No",
  col_BeneficiaryAccNo: "Beneficiary A/C No",
  col_BeneficiaryIFSC: "Beneficiary IFSC",
  col_BeneficiaryName: "Beneficiary Name",
  col_Remittercode: "Remitter Code",
  col_RemitterMobileNo: "Remitter Mob No.",
  col_Status: "Status",
  transferType: "Transfer Type",
  transferTypeReq: "Transfer Type is required",
  fromAccNo: "From Account Number",
  BeneNickname: "Beneficiary Nickname",
  BeneAccountNo: "Beneficiary Account No.",
  BeneAccountNoPlaceholder: "Select Beneficiary Account Number",
  BeneAccountNoReq: "Beneficiary Account No. is required",
  BeneIFSCCode: "Beneficiary IFSC Code",
  BeneIFSCCodeReq: "Beneficiary IFSC Code is required",
  BeneficiaryNameReq: "Beneficiary Name is required",
  BeneNicknamePattern: "Beneficiary Name must be no more than 10 digits long",
  BeneNicknameReq: "Beneficiary Nickname is required",
  selectBeneNickname: "Select Beneficiary Nickname",
  transferMethod: "Transfer Method",
  fundTransferTableHeading: "Approval Pending Transaction",

  bulkPaymentUploadHeading: "Bulk Payment Upload",
  recentBulkUploadTransaction: "Recent Bulk Upload Transaction",
  col_preview: "Preview",
  col_fileName: "File Name",
  col_totalAmount: "Total Amount",
  col_transferMethod: "Transfer Method",
  col_bulkfromaccount: "From Account",
  colCreatedBy: "Created By",
  colCreatedDate: "Created Date",
  col_bulkStatuys: "Status",
  sampleFileCSV: "Sample File CSV",
  sampleFileText: "Sample File Text",
  resetButton: "Reset",
  submitBulkButton: "Submit",
  attachFileUpload: "Attach/File Upload",

  //Checker Recent Transaction
  colRT_View: "View",
  colRT_TDate: "Transaction Date",
  colRT_TType: "Transaction Type",
  colRT_Amount: "Amount",
  colRT_RRNNo: "RRN No",
  colRT_RemAccNo: "Remitter A/C No",
  colRT_BenName: "Beneficiary Name",
  colRT_BenAccNo: "Beneficiary A/C No",
  colRT_BenIfsc: "Beneficiary IFSC",
  colRT_CBSrecDate: "CBS Received Date",
  colRT_CBSsendDt: "CBS Send Date",
  colRT_CBSRRN: "CBS RRN",
  colRT_RemCode: "Remitter Code",
  colRT_RemMobNo: "Remitter Mo No.",
  colRT_Status: "Status",
  colRT_Narration: "Narration",
  colRT_Renarks: "Remarks",
  colRT_UploadedBy: "Uploaded By",
  colRT_UploadedDate: "Uploaded Date",
  colRT_CheckedBy: "Checked By",
  colRT_CheckedDate: "Checked Date",
  colRT_AuthBy: "Auth By",
  colRT_AuthDate: "Auth Date",
  colRT_RejectedBy: "Rejected By",
  colRT_RejectedDate: "Rejected Date",
  applyButtonChecker: "Apply",

  //Beneficiary Authorize
  beneficiary_List: "Beneficiary List",
  colBenAuthorizeNickname: "Nickname",
  colBenAuthorizeName: "Name",
  colBenAuthorizeAccNum: "Account Number",
  colBenAuthorizeIFSC: "IFSC",
  colBenAuthorizeDelete: "Delete",
  AuthDenyButton: "Authorize/Deny",
  AuthDenyConfirmationMessage: "Are You Sure You Want To Authorize/Deny Beneficiary ?",

  //Checker Transaction Report
  CHTranxReportHeading: "Transaction Report",
  CHTranxReportFromDate: "From Date",
  CHTranxReportToDate: "To Date",
  CHTranxReportTType: "Transaction Type",
  CHTranxReportTTypeReq: "Transaction Type is required",
  CHTranxReportStatus: "Status",
  CHTranxReportStatusPlaceholder: "Select Status",

  //Bulk Payment Preview
  BulkPaymentPreviewHeading: "Bulk Payment Preview",
  RecentBulkUploadTransaction: "Recent Bulk Upload Transaction",

  //Transaction Approve
  TransactionApproveHeading: "Transaction Approve",
  SortPage: "Page Size",
  NoOfRecords: "Number of records",
  APPROVEDENYButton: "APPROVE/DENY",
  AUTHORIZEDENYButton: "AUTHORIZE/DENY",
  BatchCodeHeading: "Batch Code",
  batchcode_is_required:"Batch Code is required",

  //Transaction Authorize
  TransactionAuthorizeHeading: "Transaction Authorize",

  //corporate users
  colViewUser: "View",
  colActiveInactiveUser: "Active/Inactive",
  colNameOfUser: "Name of User",
  colUserID: "User ID",
  colUserRole: "User Role",
  colCorporateId: "Corporate ID",
  colCorporateName: "Corporate Name",
  colEmailId: "Email ID",
  colAddressUser: "Address",
  colMobileNoUser: "Mobile No",
  colStatusUser: "Status",
  colAuthStatusUser: "Auth Status",
  colCreatedDateUser: "Created Date",

  // Loan Payment
  customerNoLoan: "Customer Number",
  customerNoLoanReq: "Customer Number is required",
  loans_loanAccountNumber: "Loan Account Number",
  loans_loanAccountNumberRequired: "Loan Account Number is required",
  loan_LoanAccountType: "Loan Account Type",
  loan_LoanAccountTypeReq: "Loan Account Type is required",
  loan_LoanAccountHolderName: "Loan Account Holder Name",
  loan_LoanAccountHolderNameReq: "Loan Account Holder Name is required",
  LoanEMIAmount: "Loan EMI Amount",
  LoanEMIAmountReq: "EMI Amount is required",
  loanTransactionAmount: "Transaction Amount",
  loanTransactionAmountReq: "Transaction Amount is required",
  loanRemark: "Remark",
  loanRemarkReq: "Remark is required",
  loanApplyButton: "Apply",

  //Card Details
  card_Hi: "Hi",

  //CORPORATECARDDASHBOARD
  cor_card_hi: "Hi",
  cor_card_Balance: "Balance",


  //OTP 
  OTP_heading: "Please Enter OTP",
  OTP_mainHeading: "OTP Verification",
  otp_title: "Enter the verification code we just sent to your number.",
  otplimits: "You have",
  otplimitstext: "attempt left",
  otpSubmit: "Submit",

  //Routes
  routeHome: "Home",
  routeAccount: "Account",
  routeSetCustLimit: "SET ACCOUNT LIMIT",
  routeViewStatement: "View Statement",
  routeBeneficiaryMaster: "Beneficiary Master",
  routeOtherBank: "Other Bank",
  routeWithinbank: "Within Bank",
  routeFundTransfer: "Fund Transfer",
  routeNEFTFundTransfer: "NEFT",
  routeRTGSFundTransfer: "RTGS",
  routeSelfAccount: "Self Account",
  routePyamentSuccess: "Payment Success",
  routeNEFTDetails: "Neft Details",
  routeReceipt: "Receipt",
  routeRTGSDetails: "RTGS Details",
  routeInternalDetails: "Internal Details",
  routeTransactionReceipt: "Transaction Receipt",
  routeTransferHistory: "Transfer History",
  routeCards: "Cards",
  routeLoans: "Loans",
  routeloansFields: "loansfields",
  routeloansPayment: "loanspayment",
  routeLoansDETAILS: "Loan Details",
  routeDisbursementDetails: "Disbursement Details",
  routeRepaymentDetails: "Repayment Details",
  routeViewStmt: "View Statement",
  routeDeposit: "Deposit",
  routeDepositAccDetails: "Deposit Account Details",
  routeInterestRate: "Interest Rate",
  routeOpenNewDeposit: "Open New Deposit",
  routeStmts: "Statements",
  routeCheque: "Cheque",
  routeRequest: "Request",
  routeStatus: "Status",
  routeStopPayment: "Stop Payment",
  routePositivePay: "Positive Pay",
  routeCertificattes: "Certificates",
  routeProfile: "Profile",
  routeCustSupport: "Customer Support",
  routeRaiseComplaint: "Raise Complaint",

  //Corporate Maker
  routeCorHome: "Home",
  routeCorAccount: "Account",
  routeCorLimit: "SET ACCOUNT LIMIT",
  routeCorViewStmt: "View Statement",
  routeCorLoanDetails: "Loan Details",
  routeCorBeneficiaryMaster: "Beneficiary Master",
  routeCorOtherBank: "Add Other Bank",
  routeCorWithBank: "Add Within Bank",
  routeBrowse: "Browse",
  routePayments: "Payments",
  routeCorFundTransfer: "Fund Transfer",
  routeCorSelfAccount: "Self Account",
  routeCorBulkPyment: "Bulk Payment Upload",
  routeCorTranxReport: "Transaction Report",
  routeBulkUploadPreview: "Bulk Upload Preview",
  routeFundTransferPreview: "Fund Transfer Preview ",
  routeBulkFundTransferpreview: "Bulk Fund Transfer Preview",
  routeCorLoans: "Loans",
  routeloansFields: "loansfields",
  routeCorloansPayment: "loanspayment",
  routeCorLoansDETAILS: "Loan Details",
  routeCorDisbursementDetails: "Disbursement Details",
  routeCorRepaymentDetails: "Repayment Details",
  routeCorViewStmt: "View Statement",
  routeCorDeposit: "Deposit",
  routeCorDepositAccDetails: "Deposit Account Details",
  routeCorInterestRate: "Interest Rate",
  routeCorOpenNewDeposit: "Open New Deposit",
  routeCorStmts: "Statements",
  routeCorProfile: "Profile",
  routeCorUser: "User's",
  //Corporate Checker
  routeCorChckHome: "Home",
  routeCorAccount: "Account",
  routeCorAccLimit: "SET ACCOUNT LIMIT",
  routeCorViewStmt: "View Statement",
  routeCorLoanDetails: "Loan Details",
  routeCorTrxReport: "Transaction Report",
  routeCheckPreview: "Checker Preview Record",
  routeCheckBulkPreview: "Bulk Preview",
  routeCheckBulkFundTrasfer: "Checker Preview",
  routeCheckApprove: "Transaction Approve",
  routeCheckViewRecord: "Checker View Record",
  routeCheckApprove: "Checker Approve",

  //Corporate Authorize
  routeAuthHome: "Home",
  routeAuthBulkPrevuew: "Bulk Preview",
  routeAuthTransactionReport: "Transaction Report",
  routeAuthViewRecord: "Checker View Record",
  routeAuthBulkPreview: "Bulk Preview",
  routeAuthPreview: "Preview",
  routeAuthTranxAuth: "Transaction Authorize",
  routeAuthApprove: "Approve",
  routeBenAuthorize: "Beneficiary Authorize",

  //New Dashboard
  dashQuickTransfer:"Quick Transfer",
  dashNotransactionsyet:"No transactions yet",
  dashNotransactionsyetDesc:"After your first transaction you will be able to view it here",
  dashAddnew:"Add new",
  dashAccountstatement:"Account statement",
  dashQuickLinks:"Quick Links",
  dashAccountdetails:"Account details",
  dashAccountstatements:"Account statements",
  dashFundtransfer:"Fund transfer",
  dashGenerateQRCode:"Generate QR Code",
  dashRecentTransactions:"Recent Transactions",
  dashSeeall:"See all",
  dashCreateTransactions:"Create Transactions",

};